<template>
  <div>
    <div v-if="isFilterApplied" class="d-flex justify-content-end mb-3">
      <a
        href="javascript:;"
        class="btn btn-secondary w-60 display-6"
        @click="handleClearFilters"
      >
        Clear Filters
      </a>
    </div>
  </div>
  <form @submit.prevent="handleFilters">
    <div class="row filter-row">
      <div class="col-sm-6 col-md-2">
        <div
          class="input-block mb-3 form-focus"
          :class="{ focused: isFocused }"
        >
          <input
            type="text"
            :style="`${
              filters.employee_id && 'border-bottom: var(--primary-color) 2px solid;'
            }`"
            class="form-control floating"
            v-model="filters.employee_id"
            @focus="isFocused = true"
            @blur="isFocused = employee_id !== ''"
          />
          <label class="focus-label">Employee ID</label>
        </div>
      </div>
      <div class="col-sm-6 col-md-2">
        <div
          class="input-block mb-3 form-focus"
          :class="{ focused: isFocusedOn }"
        >
          <input
            type="text"
            class="form-control floating"
            :style="`${
              filters.employee_name && 'border-bottom: var(--primary-color) 2px solid;'
            }`"
            v-model="filters.employee_name"
            @focus="isFocusedOn = true"
            @blur="isFocusedOn = employee_name !== ''"
          />
          <label class="focus-label">Employee Name</label>
        </div>
      </div>
      <!-- <div class="col-sm-6 col-md-2 position-relative">
        <div class="input-block mb-3 form-focus select-focus">
          <vue-select
            :style="`${ filters.leave_type_id && 'border-bottom: var(--primary-color) 2px solid;'}`"
            :options="leaveTypes"
            v-model="filters.leave_type_id"
            placeholder="Select Leave Type"
            id="leaveType"
            :disabled="leaveTypesLoading"
            @mouseenter.once="fetchLeaveTypes"
          />
          <label class="focus-label">Leave Type</label>
        </div>
        <i
          v-if="filters.leave_type_id"
          @click="handleClearOneFilter('leave_type_id')"
          class="fa-solid fa-x"
          :style="{ position: 'absolute', top: '-20px', right: '0px', cursor: 'pointer' }"
        ></i>
      </div> -->
      <!-- <div class="col-md-3"></div> -->
      <div class="d-flex col-sm-6 col-md-3 gap-2">
        <button
          type="submit"
          href="javascript:;"
          class="btn btn-success w-100"
          @click.prevent="handleFilters"
        >
          Search
        </button>
        <button
          type="button"
          href="javascript:;"
          class="btn btn-success w-100"
          @click.prevent="resetAllFilters"
        >
          Reset
        </button>
      </div>
    </div>
  </form>
</template>

<script>
import LeaveTypeService from "@/services/LeaveTypeService";

export default {
  data() {
    return {
      filters: {
        employee_id: "",
        employee_name: "",
        // leave_type_id: "",
      },
      isFocused: false,
      isFocusedOn: false,
      leaveTypes: [],
      leaveTypesLoading: false,
      leaveTypesLoaded: false,
      searched: false,
    };
  },
  props: {
    forClient: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleFilters() {
      this.searched = true;
      this.$emit("apply-filters", this.filters);
    },

    handleClearOneFilter(fieldName) {
      this.filters[fieldName] = "";
      const filtersHasProperty = Object.values(this.filters).filter(
        (el) => !!el
      ).length;
      if (this.searched) {
        this.$emit("apply-filters", this.filters);
      }
      if (!filtersHasProperty) {
        this.searched = false;
      }
    },

    resetAllFilters() {
      Object.keys(this.filters).forEach((key) => {
        this.filters[key] = "";
      });

      this.$emit("apply-filters", this.filters);

      this.searched = false;
    },

    async fetchLeaveTypes() {
      if (this.leaveTypesLoading || this.leaveTypesLoaded) return;
      this.leaveTypesLoading = true;
      try {
        const response = this.forClient ? await LeaveTypeService.fetchClientLeaveTypes() : await LeaveTypeService.fetchLeaveTypes();
        this.leaveTypes = response?.data.map((el) => ({
          id: el.id,
          text: el.leave_type,
        }));
        this.leaveTypesLoaded = true;
      } catch (error) {
        console.error("Error fetching leave types:", error);
      } finally {
        this.leaveTypesLoading = false;
      }
    },

    handleClearFilters() {
      this.$emit("apply-filters", {});
      this.filters = {
        employee_id: "",
        employee_name: "",
        // leave_type_id: "",
      };
      this.searched = false;
    },
  },
  created() {
    this.searched = false;
  },

  computed: {
    isFilterApplied() {
      const filtersHasProperty = Object.values(this.filters).filter(
        (el) => !!el
      ).length;

      return this.searched && filtersHasProperty;
    },
  },
};
</script>
